import React from "react";
import './index.sass'
import Svg from '../../components/Svg'
import Qrcode from './com/Qrcode'
import {tokenStatus, USE_ABLE} from "../../store/token";
import {state} from '../../store';

export default class Login extends React.Component {

    constructor (props) {
        super(props)
        this.state = {}
        let status = tokenStatus(state);
        if (status === USE_ABLE) {
            this.props.history.push({pathname: '/'})
        }
    }

    render () {
        return (

            <div className='login'>
                <div className='content'>
                    <Svg.logoT className='svg mgt70'/>
                    <p className='mgt20 mgb100 desc'>助力触达千万私域创业者</p>

                    <div className='qrcode mgb40'>
                        <Qrcode></Qrcode>
                    </div>
                    {/*<p className='font24 colorfff mgb20'>Copyright © 合肥涌现信息技术有限公司 《隐私协议》</p>*/}
                    {/*<p className='font24 colorfff'>法律申明 皖ICP备 18009712号-2</p>*/}
                    <p className='font24 colorfff mgb20'>Copyright © 合肥涌现信息技术有限公司 <a href="https://beian.miit.gov.cn/">皖ICP备2021003443号-2</a></p>
                </div>
            </div>
        )
    }
}